import type { FileMapDataSubcategory } from '../types'
import { litAbsentAreaDataLegend, litAreaLayers, litAreaLegends } from './layers/lit'
import { wrapSourceLayers } from './layers/utils/wrapSourceLayers'

const subcatId = 'lit_highway_areas'
const source = 'tilda_highwayAreas'
const sourceLayer = 'highwayAreas'
export type SubcatLitHighwayAreasId = typeof subcatId
export type SubcatLitHighwayAreasStyleIds = 'default'

export const subcat_lit_highway_areas: FileMapDataSubcategory = {
  id: subcatId,
  name: 'Straßenflächen',
  ui: 'checkbox',
  // Above landuse/aeroway (the default fill slot is under `landuse`), below road lines.
  beforeId: 'atlas-app-beforeid-below-road',
  sourceId: source,
  styles: [
    {
      id: 'default',
      name: 'Beleuchtung',
      layers: wrapSourceLayers({
        layers: litAreaLayers(),
        source,
        sourceLayer,
        idPrefix: sourceLayer,
      }),
      legends: [...litAreaLegends, litAbsentAreaDataLegend],
    },
  ],
}
